import { useState, useEffect } from 'react';
import $ from 'jquery'
import publications from './publications.json';


function Research(){
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        setPosts(publications.map(d => {
                    return (
                        <>
                            <li>
                                <h6>{d.authors.join(', ').trimEnd()}. <b>{d.title}</b></h6>
                                <a target="_" href={d.link}>Link to article</a>
                                <p></p>
                                <h6><b>Abstract:</b> {d.summary.replace(/otimes/g,'x').replace(/rightarrow/g,'->').replace(/mathk/g,'').replace(/mathbb/g,'').replace(/mathbf/g,'').replace(/alpha/g,'a').replace(/beta/g,'b').replace(/\\/g,'').replace(/\$/g,'').replace(/\{/g,'').replace(/\}/g,'').replace(/\[/g,'').replace(/\]/g,'')}</h6>
                            </li>
                        </>
                    );
                }))

        /*arxiv_search({author:'Elhamdadi+Mohamed'}).done(
            res => {
                let data = res.sort((a,b) => new Date(b.date)-new Date(a.date))

                
            }
                
        )*/
    }, [])

    return (
        <>
        <ol>
            {posts}
        </ol>
        </>
    )

    // return (
    //     <>
    //         <ol>{publications.map(d => {
    //             return (
    //                 <>
    //                     <li>
    //                         <h6>{d.authors.join(',  ')}. <b>{d.title}</b></h6>
    //                         <a target="_" href={d.link}>Link to article</a>
    //                         <p></p>
    //                         <h6><b>Abstract:</b> {d.summary.replace(/otimes/g,'x').replace(/rightarrow/g,'->').replace(/mathk/g,'').replace(/mathbb/g,'').replace(/mathbf/g,'').replace(/alpha/g,'a').replace(/beta/g,'b').replace(/\\/g,'').replace(/\$/g,'').replace(/\{/g,'').replace(/\}/g,'').replace(/\[/g,'').replace(/\]/g,'')}</h6>
    //                     </li>
    //                 </>
    //             );
    //         })}</ol>
    //     </>
    // )
}

export default Research;